import { Button, Stack } from '@mui/material';

interface Props {
  onBack?: () => void;
  onNext?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
}

export default function StepActions({ onBack, onNext, nextLabel = 'Następny krok', nextDisabled }: Props) {
  return (
    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ pt: 1 }}>
      {onBack && (
        <Button variant="outlined" className="previousStep" onClick={onBack}>
          Poprzedni krok
        </Button>
      )}
      {onNext && (
        <Button
          variant="contained"
          color="secondary"
          className="nextStep"
          disabled={nextDisabled}
          onClick={onNext}
        >{nextLabel}</Button>
      )}
    </Stack>
  );
}
